<template>
    <div class="collection-slider">
      <div class="container px15">
        <div class="row">
          <div class="col-md-12">
            <div class="center-xs cool-stuff-collection">
              <div>
                <div class="slider" v-if="products.length > 0">
                  <button class="slick-button slick-button-prev responsibility"
                          :class="{ 'slick-button-green': currentPage < total - slidesPerPage }"
                          @click="showNext"
                  >
                    <i class="material-icons p15 pointer">keyboard_arrow_right</i>
                  </button>
                  <VueSlickCarousel
                    v-bind="config"
                    ref="slick"
                    class="category-sliders"
                    @afterChange="setMuted"
                  >
                    <div
                      v-for="product in products"
                      :key="product._source.id"
                    >
                      <product-tile-slider
                        class="collection-product"
                        :product="product._source"
                        :labels-active="false"
                        :only-image="false"
                      />
                    </div>
                  </VueSlickCarousel>
                  <button class="slick-button slick-button-next responsibility"
                          :class="{ 'slick-button-green': currentPage > 0 }"
                          @click="showPrevious"
                  >
                    <i class="material-icons p15 pointer">keyboard_arrow_left</i>
                  </button>
                </div>
                <div v-else class="container ">
                  <preloader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ProductTileSlider from 'theme/components/core/ProductTileSlider'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import Preloader from 'theme/components/theme/blocks/Home/Preloader'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { mapActions } from 'vuex'

export default {
  name: 'ProductsSlider',
  props: {
    title: {
      type: String,
      default: ''
    },
    products: {
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    categoryIds: {
      type: Array,
      required: true
    },
    category: {
      type: Object,
      required: true
    }
  },
  components: {
    VueSlickCarousel,
    ProductTileSlider,
    Preloader
  },
  data () {
    return {
      maxPage: 0,
      currentPage: 0,
      size: 12
    }
  },
  computed: {
    slidesPerPage () {
      if (window.innerWidth < 480) {
        return 2;
      }
      if (window.innerWidth < 600) {
        return 3;
      }
      if (window.innerWidth < 1024) {
        return 4;
      }
      return 6;
    },
    currentPartnerCode () {
      return this.$route.params.store
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    }
  },
  beforeMount () {
    this.updateProducts()
  },
  methods: {
    ...mapActions({
      updateSliderProducts: 'products_categories/updateProducts',
      getProductsList: 'product/list'
    }),
    updateProducts (size = 12) {
      this.updateSliderProducts({
        category: this.category,
        categoryIds: this.categoryIds,
        size: size,
        store: this.$route.params.store
      })
    },
    showNext () {
      this.$refs.slick.next();
    },
    showPrevious () {
      this.$refs.slick.prev();
    },
    setMuted (currentPage) {
      if (currentPage > this.maxPage) {
        this.maxPage = currentPage;
        if (this.total > currentPage) {
          this.loadMoreProducts()
        }
      }
      this.currentPage = currentPage
    },
    loadMoreProducts () {
      this.size += 6
      this.updateProducts(this.size)
    },
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-product-bg: color(secondary, $colors-background);
.slick-button {
  z-index: 1;
  border: 0px;
  border-radius: 50%;
  transition: opacity 200ms linear 0s;
  text-align: left;
  line-height: 1;
  color: rgb(255, 255, 255);
  width: 55px;
  height: 55px;
  padding: 0;


  i{
    font-size: 28px;
      padding: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
  }
}

.slick-button-green {
  background-color: rgba(0, 0, 0, 0.9);
  box-shadow: rgba(0, 0, 0, 0.26) 0px 1px 2px 0px, rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
}

.slick-button-prev {
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  i{
    left: 5px;
  }
}

.slick-button-next {
  position: absolute;
  left: -25px;
  top: 50%;
  transform: translateY(-50%);
  i{
    right: 5px;
  }
}

.slider {
  position: relative;
  overflow: hidden;
}


.category-sliders {
  height: 260px;
}

.product {
  &.collection-product {
    padding: 0;
  }
}

.collection-product {
  .product-link {
    display: block;
    padding: 0 15px;
  }

  .product-image {
    height: auto;
    will-change: opacity;

    img {
      max-width: 100%;
      max-height: 100%;
      height: auto;
      vertical-align: bottom;
    }
  }
}
.view-more-categ{
    font-weight: 800;
    font-size: 18px;
    text-transform: uppercase;
}
.view-more{
    color: #11bb2e;
    font-size: 14px;
    font-weight: 300;
    text-decoration: underline;
}
.collection-header{
    @media only screen and (max-width: 768px){
        padding-left: 10px;
        padding-right: 10px;
    }
    h3{
        @media only screen and (max-width: 768px){
            padding-left: 8px;
            padding-right: 8px;
        }
    }
    .custom-title{
        color: #333;
    }
}
a.view-more.underline:after,
a.view-more:not(.no-underline):hover:after {
    background-color: #11bb2e;
}
    .collection{
      background-color: #fff;
      padding-top: 60px;
      margin-top: -15px;
    }

</style>
